import { combineReducers } from 'redux'

// reducer import
import customizationReducer from './customizationReducer'
import authReducer from './authReducer'
import notificationReducer from './notificationReducer'
import downloadReducer from './downloadReducer'

// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
  customization: customizationReducer,
  auth: authReducer,
  notification: notificationReducer,
  download: downloadReducer
})

export default reducer
